import React, { useState } from 'react';
import PropTypes from 'prop-types';

const PromoCodeInputContext = React.createContext(undefined);

export function PromoCodeInputContextProvider({ children }) {
  const [promoCodeInputIsFilled, setPromoCodeInputIsFilled] = useState(false);
  const [promoCodeInputResource, setPromoCodeInputResource] = useState(undefined);
  return (
    <PromoCodeInputContext.Provider
      value={{
        promoCodeInputIsFilled,
        setPromoCodeInputIsFilled,
        promoCodeInputResource,
        setPromoCodeInputResource,
      }}
    >
      {children}
    </PromoCodeInputContext.Provider>
  );
}

PromoCodeInputContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function usePromoCodeInputContext() {
  const context = React.useContext(PromoCodeInputContext);

  if (!context) {
    throw new Error(
      'usePromoCodeInputContext must be called from a PromoCodeInputFilledContext.Provider',
    );
  }

  return context;
}
